<template>
    <div>
        <div>
            <h3 class="title title--s title--uppercase create__delivey-title">{{ $lang('Delivery.location.title') }}</h3>

            <div class="create__delivey-method">
                <!--Бесплатный самовывоз-->
                <div v-if="regions.length" class="create__delivey-method__item shadow"
                     :class="{active: cemeteryActive}"
                     @click="onSelectCemetery">
                    <div class="form__label form__label--big form__label--no-upper">{{ $lang('Delivery.location.method.cemetery.title') }}</div>

                    <p class="create__description create__description--mb">{{ $lang('Delivery.location.method.cemetery.text') }}</p>

                    <button v-if="cemeteryActive" class="btn btn--bottom link link--no-angle">
                        <span>{{ $lang('Delivery.location.method.cemetery.selected') }}</span>
                    </button>

                    <button dusk="open-select-cemetery" v-else class="btn btn--bottom link">
                        <span>{{ $lang('Delivery.location.method.cemetery.select') }}</span>
                    </button>
                </div>

                <!--Доставка boxberry-->
                <div v-if="locale === 'ru'"
                     class="create__delivey-method__item shadow"
                     :class="{active: boxberryActive}"
                     @click="boxberryActive = true">
                    <div class="form__label form__label--big form__label--no-upper">{{ $lang('Delivery.location.method.boxberry.title') }}</div>

                    <p class="create__description create__description--mb">{{ $lang('Delivery.location.method.boxberry.text') }}</p>

                    <button v-if="boxberryActive" class="btn btn--bottom link link--no-angle">
                        <span>{{ $lang('Delivery.location.method.boxberry.selected') }}</span>
                    </button>

                    <button v-else class="btn btn--bottom link">
                        <span>{{ $lang('Delivery.location.method.boxberry.select') }}</span>
                    </button>
                </div>

                <!--Табличка не нужна-->
                <div class="create__delivey-method__item shadow" v-if="!hiddenNoTable">
                    <div class="form__label form__label--big form__label--no-upper">{{ $lang('Delivery.location.method.pickup.title') }}</div>

                    <p class="create__description create__description--mb">{{ $lang('Delivery.location.method.pickup.text') }}</p>

                    <button dusk="no-table" class="btn btn--bottom link" @click="$emit('noTable')">
                        <span>{{ $lang('Delivery.location.method.pickup.btn') }}</span>
                    </button>
                </div>
            </div>
        </div>

        <div class="create__delivey-info" v-show="cemeteryActive">
            <!--Выбор города-->
            <div class="form__label">{{ $lang('Delivery.location.cemetery.region.label') }}</div>

            <div class="form__item form__item--relative form__item--inline">
                <div class="form__item--inline form__item--inline-column form__item--inline-half create__delivey-info__cemetery">
                    <el-popover v-model="errors.region.isError"
                                trigger="manual"
                                placement="top"
                                width="300"
                                popper-class="add__error-popover"
                                :content="errors.region.message">
                        <el-select slot="reference"
                                   dusk="select-region"
                                   v-dusk="'input-country'"
                                   :class="{ 'add__error': errors.region.isErrorPaint }"
                                   filterable
                                   clearable
                                   popper-class="create__delivey-cemetery"
                                   v-model="selectedRegionId"
                                   :placeholder="$lang('Delivery.location.cemetery.selectCemetery.placeholder')"
                                   :loading-text="$lang('el-select.loading')"
                                   :noDataText="$lang('el-select.noDataText')"
                                   :noMatchText="$lang('el-select.noMatchText')"
                                   @focus="clearErrors">
                            <el-option v-for="region in regions"
                                       :key="region.id"
                                       :label="region.name"
                                       :value="region.id">
                            </el-option>
                        </el-select>
                    </el-popover>
                </div>
            </div>

            <div v-if="selectedRegionId">
                <div class="form__item" v-if="pickups.length">
                    <!--Самовывоз у партнера-->
                    <div class="form__label">{{ $lang('Delivery.location.cemetery.pickup.label') }}</div>

                    <div class="create__delivey-method">
                        <div class="create__delivey-method__item shadow"
                             :class="{active: pickup === selectedPickup}"
                             v-for="pickup in pickups">
                            <div class="form__label form__label--big form__label--no-upper">{{ pickup.name }}</div>

                            <p class="create__description create__description--mb">{{ pickup.address }}</p>

                            <p class="create__description create__description--mb">{{ pickup.hours }}</p>

                            <button v-if="pickup === selectedPickup" class="btn btn--bottom link link--no-angle">
                                <span>{{ $lang('Delivery.location.method.cemetery.selected') }}</span>
                            </button>

                            <button dusk="open-select-cemetery" v-else class="btn btn--bottom link" @click="selectedPickup = pickup">
                                <span>{{ $lang('Delivery.location.method.cemetery.select') }}</span>
                            </button>
                        </div>
                    </div>
                </div>

                <div class="form__item" v-if="cemeteries.length">
                    <!--Выбор кладбища-->
                    <div class="form__label">{{ $lang('Delivery.location.cemetery.selectCemetery') }}</div>

                    <div class="form__item form__item--relative form__item--inline">
                        <div class="form__item--inline form__item--inline-column form__item--inline-half create__delivey-info__cemetery">
                            <el-popover v-model="errors.cemetery.isError"
                                        trigger="manual"
                                        placement="top"
                                        width="300"
                                        popper-class="add__error-popover"
                                        :content="errors.cemetery.message">
                                <el-select slot="reference"
                                           dusk="select-cemetery"
                                           :class="{ 'add__error': errors.cemetery.isErrorPaint }"
                                           filterable
                                           clearable
                                           popper-class="create__delivey-cemetery"
                                           v-model="cemeteryId"
                                           :placeholder="$lang('Delivery.location.cemetery.selectCemetery.placeholder')"
                                           :loading-text="$lang('el-select.loading')"
                                           :noDataText="$lang('el-select.noDataText')"
                                           :noMatchText="$lang('el-select.noMatchText')"
                                           @focus="clearErrors">
                                    <el-option v-for="item in cemeteries"
                                               :key="item.id"
                                               :label="item.name"
                                               :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-popover>
                        </div>

                        <div v-if="locale === 'ru' && !pickups.length" class="form__item--inline form__item--inline-column form__item--inline-half">
                            <button class="btn btn--dashed" @click="cemeteryHintVisible = !cemeteryHintVisible">
                                <span>{{ $lang('Delivery.location.cemetery.noCemetery') }}</span>
                            </button>

                            <div v-if="cemeteryHintVisible" class="a-filters__hint a-filters__hint--absolute a-filters__hint--thin a-filters__hint--margin-small">{{ $lang('Delivery.location.cemetery.noCemetery.hint') }}</div>
                        </div>
                    </div>
                </div>

                <button v-if="cemetery || selectedPickup" dusk="to-order"
                        class="btn btn--main-bg btn--middle"
                        :class="{ active: cemeteryId }"
                        @click="submit">
                    {{ $lang('Delivery.location.cemetery.goToPay') }}
                </button>
                <button v-else disabled
                        class="btn btn--main-bg btn--middle">
                    {{ $lang('Delivery.location.cemetery.goToPay') }}
                </button>
            </div>
        </div>

        <div class="create__delivey-info" v-show="boxberryActive">
            <div id="boxberry-map"></div>
        </div>
    </div>
</template>

<script>
import {mapActions, mapMutations} from "vuex";
import mixin from "../../mixins/errors";
import Vue from "vue";
import ApiService from "../../api/api";

export default {
    name: 'DeliveryLocation',
    props: ['delivery', 'hiddenNoTable'],
    mixins: [mixin],
    data() {
        return {
            cemeteryActive: false,
            cemeteries: null,
            cemeteryId: null,
            cemetery: null,
            locale: window.laravel.locale,
            boxberryActive: false,
            boxberry: null,
            cemeteryHintVisible: false,
            errors: {
                cemetery: {
                    isError: false,
                    message: Vue.prototype.$lang('Delivery.location.cemetery.selectCemetery.error')
                },
                region: {
                    isError: false,
                    message: ''
                }
            },
            regions: [],
            selectedRegionId: null,
            selectedRegion: null,
            pickups: [],
            selectedPickup: null,
        }
    },
    directives: {
        dusk: {
            bind(el, binding) {
                const input = el.querySelector('.el-input__inner');

                input.setAttribute('dusk', binding.value);
            }
        }
    },
    created() {
        this.setModal(1200);

        this.getRegions();
    },
    watch: {
        cemeteryActive: function(val) {
            if (val) {
                this.boxberryActive = false;
            }
        },
        boxberryActive: function(val) {
            if (val) {
                this.cemeteryActive = false;

                document.getElementById('boxberry-map').innerHTML = '';

                this.$nextTick(() => {
                    boxberry.openOnPage('boxberry-map');

                    boxberry.open(
                        this.boxberryCallback,
                        window.laravel.boxberry.token,
                        'Москва',
                        '',
                        0,
                        window.laravel.boxberry.table.weight,
                        0,
                        window.laravel.boxberry.table.height,
                        window.laravel.boxberry.table.width,
                        window.laravel.boxberry.table.depth
                    );
                });
            }
        },
        selectedRegionId: function(id) {
            this.selectedRegion = this.regions.filter(region => {
                return region.id === id;
            })[0];

            this.pickups = this.selectedRegion.active_pickups;

            this.cemeteries = this.selectedRegion.cemetries_with_pickup;
            this.selectedPickup = null;
            this.cemetery = null;
        },
        cemeteryId: function(id) {
            if (id !== null) {
                this.cemetery = this.cemeteries.filter(cemetery => {
                    return cemetery.id === id;
                })[0];

                this.selectedPickup = null;
            }
        },
        selectedPickup: function(pickup) {
            if (pickup !== null) {
                this.cemeteryId = null;
                this.cemetery = null;
            }
        },

    },
    methods: {
        ...mapMutations('create', [
            'setModal'
        ]),
        boxberryCallback(result) {
            this.boxberry = result;
            this.submit();
        },
        submit() {
            if (this.cemeteryActive) {
                if (!this.cemeteryId && !this.selectedPickup) {
                    return this.errors.cemetery.isError = true;
                }
            }

            let method, methodName, address, period, phone, workschedule, price, partnerName, target;

            if (this.cemeteryActive && this.cemetery) {
                target = '';
                method = 'cemetery';
                methodName = this.$lang('Delivery.location.cemetery.pickup');
                address = this.cemetery.name + ' ' + this.cemetery.address;
                period = null;
                phone = null;
                workschedule = this.cemetery.working_hours;
                price = 0;
                partnerName = null;
            } else if (this.cemeteryActive && this.selectedPickup) {
                target = '';
                method = 'pickup';
                methodName = this.$lang('Delivery.location.partner.pickup');
                address = this.selectedPickup.address;
                period = null;
                phone = null;
                workschedule = this.selectedPickup.hours;
                price = 0;
                partnerName = this.selectedPickup.name;
            } else if (this.boxberryActive) {
                target = this.boxberry.id
                method = 'boxberry';
                methodName = this.$lang('Delivery.location.boxberry.pickup');
                address = this.boxberry.address;
                period = this.boxberry.period;
                phone = this.boxberry.phone;
                workschedule = this.boxberry.workschedule;
                price = this.boxberry.price;
                partnerName = null;
            }

          this.$emit('update:delivery', {
              target: target,
              method: method,
              methodName: methodName,
              address: address,
              period: period,
              phone: phone,
              workschedule: workschedule,
              price: price,
              partnerName: partnerName
            });
        },
        getRegions() {
            ApiService.get('/regions-with-pickup').then((response) => {
                this.regions = response.data;
            });
        },
        onSelectCemetery() {
            this.cemeteryActive = true;
        }
    },

}
</script>
